<template>
  <div>
    <b-row>
      <b-col>
        <h1>Configuración</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab title="Usuarios" active>
            <Users></Users>
          </b-tab>
          <b-tab title="Docentes" active>
            <Teachers></Teachers>
          </b-tab>
          <b-tab title="Cursos" active>
            <Courses></Courses>
          </b-tab>
          <b-tab title="Ciclos Lectivos">
            <Years></Years>
          </b-tab>
          <b-tab title="Aulas">
            <Rooms></Rooms>
          </b-tab>
          <b-tab title="Comentarios">
            <Comments></Comments>
          </b-tab>
          <b-tab title="Inscripciones">
            <Enrollments></Enrollments>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Courses from './config/Courses.vue'
import Users from './config/Users.vue'
import Teachers from './config/Teachers.vue'
import Years from './config/Years.vue'
import Rooms from './config/Rooms.vue'
import Comments from './config/Comments.vue'
import Enrollments from './config/Enrollments.vue'

export default {
  name: 'Config',
  data () {
    return {
    }
  },
  components: {
    Courses,
    Years,
    Users,
    Teachers,
    Rooms,
    Comments,
    Enrollments
  },
  watch: {

  },
  computed: {

  },
  async created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped></style>
